// src/utils/utcParse.js
// Parse various DB timestamp formats reliably as UTC Date objects.
// Handles: "YYYY-MM-DD HH:MM:SS", "YYYY-MM-DDTHH:MM:SS", "2025-11-03T19:13:15.000Z", Date objects, etc.

export function parseToUtcDate(val) {
  if (!val) return null;
  if (val instanceof Date) return val;

  // already ISO with timezone Z -> parse directly
  if (typeof val === 'string') {
    let s = val.trim();

    // If looks like "YYYY-MM-DD HH:MM:SS" -> convert to "YYYY-MM-DDTHH:MM:SSZ"
    // (many MySQL drivers return "YYYY-MM-DD HH:MM:SS" which is ambiguous in browsers)
    const reSpace = /^\d{4}-\d{2}-\d{2}\s+\d{2}:\d{2}:\d{2}(?:\.\d+)?$/;
    if (reSpace.test(s)) {
      s = s.replace(/\s+/, 'T') + 'Z';
      return new Date(s);
    }

    // If looks like "YYYY-MM-DDTHH:MM:SS" without Z -> append Z
    const reIsoNoZ = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?$/;
    if (reIsoNoZ.test(s)) {
      return new Date(s + 'Z');
    }

    // If already has timezone info or Z, Date(...) will parse correctly
    const parsed = new Date(s);
    if (!isNaN(parsed.getTime())) return parsed;

    // fallback: try appending Z one more time
    const tryZ = new Date(s + 'Z');
    if (!isNaN(tryZ.getTime())) return tryZ;

    return null;
  }

  return null;
}
